export default ["blue", "red", "green", "orange"];
